import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as SorryBuddy } from '../../../../../assets/icons/buddy-sorry.svg';
import { BreadcrumbItemProps } from '../../../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import GenericPageNE from '../../../../../shared/components/GenericPageNE/GenericPageNE';
import { TRANSLATION_LOAD_BALANCE } from '../../../../../shared/translations/rewards';
import { GenericVoidFunction } from '../../../../../shared/types/genericTypes';

interface LoadBalanceErrorProps {
  breadcrumbs: BreadcrumbItemProps[];
  retry: GenericVoidFunction;
  cancel: GenericVoidFunction;
}

const LoadBalanceError = ({ breadcrumbs, retry, cancel }: LoadBalanceErrorProps) => {
  const { t } = useTranslation();

  return (
    <GenericPageNE
      breadcrumbs={breadcrumbs}
      ImageComponent={SorryBuddy}
      title={t(TRANSLATION_LOAD_BALANCE.error.title)}
      description={{ i18nKey: TRANSLATION_LOAD_BALANCE.error.description, components: { 1: <br /> } }}
      primaryButton={{
        text: t(TRANSLATION_LOAD_BALANCE.error.primaryButton),
        action: retry
      }}
      secondaryButton={{
        text: t(TRANSLATION_LOAD_BALANCE.error.secondaryButton),
        action: cancel
      }}
    />
  );
};

export default LoadBalanceError;
